export default __webpack_public_path__ + "static/space-lines-ae5f4d65a6c75f6127b71ee89ab4fe08.png";